// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"fd8dcd6e","609":"0e00eb18","978":"8351d6dc"}[chunkId] + ".chunk.css";
};